import { useEffect, useState } from "react";
import { Col, Form, FormFeedback, Input, Label, Row } from "reactstrap";
import { useCommonDataFindAllQuery, useMeasurementGroundWaterCreateMutation, useMeasurementGroundWaterDeleteMutation, useMeasurementGroundWaterFindAllQuery, useMeasurementGroundWaterUpdateMutation } from "store";
import * as Yup from "yup";
import { useFormik } from "formik";
import Spinners from "Components/Common/Spinner";
import { Link, useParams } from "react-router-dom";
import Switch from "react-switch";
import measurementSvg from "../../../assets/images/svg/measurement.svg"
import DeleteModal from "Components/Common/DeleteModal";
import Flatpickr from "react-flatpickr";

const Measurement = () => {
  const { id } = useParams();
  const [isLoading, setLoading] = useState(true)

  const { data, error, isFetching } = useMeasurementGroundWaterFindAllQuery(`?groundwater_id=${id}`);
  const [measurementGroundWaterCreate, measurementGroundWaterCreateResult] = useMeasurementGroundWaterCreateMutation();
  const [measurementGroundWaterUpdate, measurementGroundWaterUpdateResult] = useMeasurementGroundWaterUpdateMutation();
  const [measurementGroundWaterDelete, measurementGroundWaterDeleteResult] = useMeasurementGroundWaterDeleteMutation();

  const [measurementGroundWater, setMeasurementGroundWater] = useState<any>();

  const [is_tidal, setTidalBoolean] = useState<boolean>(false);
  const [is_clean, setIs_cleanBoolean] = useState<boolean>(false);
  const [is_used, setIs_usedBoolean] = useState<boolean>(false);


  const [is_newCreated, setIs_newCreated] = useState<boolean>(false);
  const [measurementList, setMeasurementList] = useState<any>();
  const [meaCount, setMeaCount] = useState<any>();

  const {
    data: qualityData,
    error: qualityDataError,
    isFetching: isQualityDataFetching,
  } = useCommonDataFindAllQuery(`?group_name=cmd_groundwater_quality`);

  useEffect(() => {

    if (measurementGroundWater === undefined) {
      setLoading(true);
    } else {
      setLoading(false);
    }

    setMeasurementList(data?.data);
    setMeaCount(measurementList?.area);

    const tempIs_tidal = measurementGroundWater !== null ? measurementGroundWater?.is_tidal : false;
    const tempIs_clean = measurementGroundWater !== null ? measurementGroundWater?.is_clean : false;
    const tempIs_used = measurementGroundWater !== null ? measurementGroundWater?.is_used : false;

    setTidalBoolean(tempIs_tidal)
    setIs_cleanBoolean(tempIs_clean)
    setIs_usedBoolean(tempIs_used)

  }, [measurementGroundWater, qualityData, id, data?.data])


  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      id: measurementGroundWater?.id,
      groundwater_id: measurementGroundWater?.groundwater_id,
      groundwater_code: measurementGroundWater?.groundwater_code,
      measure_date: measurementGroundWater?.measure_date,
      usage_information: measurementGroundWater?.usage_information,
      sanitary_requirements: measurementGroundWater?.sanitary_requirements,
      area: measurementGroundWater?.area,
      cmd_groundwater_quality: measurementGroundWater?.cmd_groundwater_quality,
      storage_method: measurementGroundWater?.storage_method,
      storage_scheme: measurementGroundWater?.storage_scheme,
      observation_time_results: measurementGroundWater?.observation_time_results,
      report_autor: measurementGroundWater?.report_autor,
      report_code: measurementGroundWater?.report_code,
      report_name: measurementGroundWater?.report_name,
      storage_balance: measurementGroundWater?.storage_balance,
      water_physical_quality: measurementGroundWater?.water_physical_quality,
      hydrogeological_research_phase: measurementGroundWater?.hydrogeological_research_phase,
      groundwater_resource: measurementGroundWater?.groundwater_resource,
      hydrogeological_structure: measurementGroundWater?.hydrogeological_structure,
    },
    validationSchema: Yup.object({
      groundwater_code: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      measure_date: Yup.date().typeError("Он сар өдөр оруулна уу").required("Утга оруулна уу !"),
      area: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      cmd_groundwater_quality: Yup.string().typeError("Утга сонгоно уу").required("Утга оруулна уу !"),
      storage_method: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      storage_scheme: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      observation_time_results: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      storage_balance: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      water_physical_quality: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      hydrogeological_research_phase: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      groundwater_resource: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      hydrogeological_structure: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      sanitary_requirements: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("утга оруулна уу !"),
      usage_information: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      report_autor: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      report_code: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      report_name: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),


    }),
    onSubmit: (values: any) => {
      if (measurementGroundWater !== null) {
        const updateList = {
          id: measurementGroundWater?.id,
          groundwater_id: measurementGroundWater?.groundwater_id,
          groundwater_code: values.groundwater_code,
          measure_date: values.measure_date,
          usage_information: values.usage_information,
          sanitary_requirements: values.sanitary_requirements,
          area: values.area,
          cmd_groundwater_quality: values.cmd_groundwater_quality,
          storage_method: values.storage_method,
          storage_scheme: values.storage_scheme,
          observation_time_results: values.observation_time_results,
          report_autor: values.report_autor,
          report_code: values.report_code,
          report_name: values.report_name,
          storage_balance: values.storage_balance,
          water_physical_quality: values.water_physical_quality,
          hydrogeological_research_phase: values.hydrogeological_research_phase,
          groundwater_resource: values.groundwater_resource,
          hydrogeological_structure: values.hydrogeological_structure,
          is_tidal: is_tidal === undefined ? false : is_tidal,
          is_clean: is_clean === undefined ? false : is_clean,
          is_used: is_used === undefined ? false : is_used,
        }
        measurementGroundWaterUpdate(updateList);
      } else {
        const newList = {
          groundwater_id: id,
          groundwater_code: values["groundwater_code"],
          measure_date: values["measure_date"],
          usage_information: values["usage_information"],
          sanitary_requirements: values["sanitary_requirements"],
          area: values["area"],
          cmd_groundwater_quality: values["cmd_groundwater_quality"],
          storage_method: values["storage_method"],
          storage_scheme: values["storage_scheme"],
          observation_time_results: values["observation_time_results"],
          report_autor: values["report_autor"],
          report_code: values["report_code"],
          report_name: values["report_name"],
          storage_balance: values["storage_balance"],
          water_physical_quality: values["water_physical_quality"],
          hydrogeological_research_phase: values["hydrogeological_research_phase"],
          groundwater_resource: values["groundwater_resource"],
          hydrogeological_structure: values["hydrogeological_structure"],
          is_tidal: is_tidal === undefined ? false : is_tidal,
          is_clean: is_clean === undefined ? false : is_clean,
          is_used: is_used === undefined ? false : is_used,
        };
        measurementGroundWaterCreate(newList)
      }
      // validation.resetForm();
    },
  });



  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Үгүй
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Тийм
      </div>
    );
  };

  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = () => {
    setDeleteModal(true);
  };

  const handleDeletejob = () => {
    if (measurementGroundWater) {
      measurementGroundWaterDelete(measurementGroundWater.id);
      setDeleteModal(false);
    }
    setMeasurementGroundWater(null);
    setIs_newCreated(true)
  };

  return (

    <>
      <Row>
        <Col lg={12}>
          <div className="d-flex align-items-center mb-3">
            <img src={measurementSvg} alt="" height="50" />
            <div className="flex-grow-1 ms-3">
              <h5 className="fw-semibold">Мэдээлэл</h5>
              <ul className="list-unstyled hstack gap-2 mb-0">
                <li>
                  <i className="mdi mdi-table-row-height"></i>{" "}
                  <span className="text-muted fw-semibold">
                    Нийт: {meaCount}
                  </span>
                </li>
              </ul>
            </div>

            <button
              type="button"
              disabled={is_newCreated === true ? true : false}
              className="btn btn-success  btn-label me-3"
              onClick={() => {
                validation.resetForm();
                setMeasurementGroundWater(null);
                setIs_cleanBoolean(false);
                setTidalBoolean(false)
                setIs_newCreated(true);
              }}
            >
              <i className="mdi mdi-file-plus-outline label-icon"></i>
              Шинээр нэмэх
            </button>

            {
              is_newCreated === false && measurementGroundWater !== null ?
                <button
                  type="button"
                  onClick={(event: any) => {
                    event.preventDefault();
                    onClickDelete();
                  }}
                  className="btn btn-danger  btn-label"
                >
                  <i className="mdi mdi-delete-empty-outline label-icon"></i> Устгах
                </button>
                : ''
            }
          </div>
        </Col>
      </Row>
      <Row>
        <DeleteModal
          deleteName={measurementGroundWater?.report_name}
          show={deleteModal}
          onDeleteClick={handleDeletejob}
          onCloseClick={() => setDeleteModal(false)}
        />
        <Col lg={3}>
          <ul className="verti-timeline list-unstyled">
            {measurementList?.map((item, index) => (
              <li className="event-list active">
                <div className="event-timeline-dot">
                  <i className="bx bxs-right-arrow-circle font-size-18 bx-fade-right" />
                </div>
                <div className="flex-shrink-0 d-flex">
                  <div key={index} className="d-flex mb-3">
                    <div className="me-3">
                      <h5 className="font-size-14">
                        {item?.created_at.split("T")[0]}
                        <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                      </h5>
                    </div>
                    <div className="flex-grow-1">
                      <div>
                        <Link
                          to="#"
                          className="cursor fw-semibold"
                          onClick={() => {
                            setIs_newCreated(false)
                            setMeasurementGroundWater(item)
                          }}
                        >
                          {item?.measure_date}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </Col>
        <Col lg={9}>
          {
            isLoading ? <Spinners setLoading={setLoading} sCustomTop={'120px'} /> :
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <Row>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label className="fw-semibold"> Бүртгэлийн дугаар </Label>
                      <Input
                        name="groundwater_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.groundwater_code || ""}
                        invalid={
                          validation.touched.groundwater_code &&
                            validation.errors.groundwater_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.groundwater_code &&
                        validation.errors.groundwater_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.groundwater_code}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Гидрогеологийн зэрэг </Label>
                      <Input
                        name="cmd_groundwater_quality"
                        type="select"
                        className="form-select"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.cmd_groundwater_quality || ""}
                        invalid={
                          validation.touched.cmd_groundwater_quality &&
                            validation.errors.cmd_groundwater_quality
                            ? true
                            : false
                        }
                      >
                        <option disabled value="">Сонгох</option>
                        {qualityData?.data?.map((item, index) => (
                          <option value={item?.id}>{item?.name}</option>
                        ))}
                      </Input>
                      {validation.touched.cmd_groundwater_quality &&
                        validation.errors.cmd_groundwater_quality ? (
                        <FormFeedback type="invalid">
                          {validation.errors.cmd_groundwater_quality}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ажиглалтын хугацааны үр дүн </Label>
                      <Input
                        name="observation_time_results"
                        type="select"
                        className="form-select"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.observation_time_results || ""}
                        invalid={
                          validation.touched.observation_time_results &&
                            validation.errors.observation_time_results
                            ? true
                            : false
                        }
                      >
                        <option disabled value="">Сонгох</option>
                        {qualityData?.data?.map((item, index) => (
                          <option value={item?.id}>{item?.name}</option>
                        ))}
                      </Input>
                      {validation.touched.observation_time_results &&
                        validation.errors.observation_time_results ? (
                        <FormFeedback type="invalid">
                          {validation.errors.observation_time_results}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Гидрогеологийн судалгааны үе шат </Label>
                      <Input
                        name="hydrogeological_research_phase"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.hydrogeological_research_phase || ""}
                        invalid={
                          validation.touched.hydrogeological_research_phase &&
                            validation.errors.hydrogeological_research_phase
                            ? true
                            : false
                        }
                      />
                      {validation.touched.hydrogeological_research_phase &&
                        validation.errors.hydrogeological_research_phase ? (
                        <FormFeedback type="invalid">
                          {validation.errors.hydrogeological_research_phase}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Түрлэгтэй эсэх </Label> <br />
                      <Switch
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        className="me-1 mb-sm-8 mb-2 ms-3"
                        onColor="#626ed4"
                        onChange={() => {
                          setTidalBoolean(!is_tidal);
                        }}
                        checked={is_tidal}
                      />
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ашиглалтын талаарх мэдээлэл </Label>
                      <Input
                        name="usage_information"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.usage_information || ""}
                        invalid={
                          validation.touched.usage_information &&
                            validation.errors.usage_information
                            ? true
                            : false
                        }
                      />
                      {validation.touched.usage_information &&
                        validation.errors.usage_information ? (
                        <FormFeedback type="invalid">
                          {validation.errors.usage_information}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label className="fw-semibold"> Тайлангийн фондын бүртгэлийн дугаар   </Label>
                      <Input
                        name="report_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_code || ""}
                        invalid={
                          validation.touched.report_code &&
                            validation.errors.report_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_code &&
                        validation.errors.report_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_code}
                        </FormFeedback>
                      ) : null}
                    </div>

                  </Col>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Хэмжилт хийсэн огноо </Label>
                      <Flatpickr
                        className="form-control d-block"
                        placeholder="Огноо"
                        name="measure_date"
                        value={validation.values.measure_date}
                        onChange={(selectDate: Date[]) => {
                          if (selectDate[0]) {
                            const localDate = new Date(selectDate[0].getTime() - selectDate[0].getTimezoneOffset() * 60000)
                              .toISOString()
                              .split('T')[0];
                            validation.setFieldValue('measure_date', localDate);
                          }
                        }}
                        options={{
                          altInput: true,
                          altFormat: "Y-m-d",
                          dateFormat: "Y-m-d",
                          enableTime: false,
                        }}
                      />
                      {validation.touched.measure_date &&
                        validation.errors.measure_date ? (
                        <FormFeedback type="invalid">
                          {validation.errors.measure_date}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Нөөц тооцсон арга </Label>
                      <Input
                        name="storage_method"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.storage_method || ""}
                        invalid={
                          validation.touched.storage_method &&
                            validation.errors.storage_method
                            ? true
                            : false
                        }
                      />
                      {validation.touched.storage_method &&
                        validation.errors.storage_method ? (
                        <FormFeedback type="invalid">
                          {validation.errors.storage_method}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Нөөц ашиглалт (м<sup>3</sup> хоног) </Label>
                      <Input
                        name="storage_balance"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.storage_balance || ""}
                        invalid={
                          validation.touched.storage_balance &&
                            validation.errors.storage_balance
                            ? true
                            : false
                        }
                      />
                      {validation.touched.storage_balance &&
                        validation.errors.storage_balance ? (
                        <FormFeedback type="invalid">
                          {validation.errors.storage_balance}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Нөөц баялаг (м<sup>3</sup>хоног) </Label>
                      <Input
                        name="groundwater_resource"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.groundwater_resource || ""}
                        invalid={
                          validation.touched.groundwater_resource &&
                            validation.errors.groundwater_resource
                            ? true
                            : false
                        }
                      />
                      {validation.touched.groundwater_resource &&
                        validation.errors.groundwater_resource ? (
                        <FormFeedback type="invalid">
                          {validation.errors.groundwater_resource}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Эрүүл ахуйн шаардлага хангасан эсэх </Label> <br />
                      <Switch
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        className="me-1 mb-sm-8 mb-2 ms-3"
                        onColor="#626ed4"
                        onChange={() => {
                          setIs_cleanBoolean(!is_clean);
                        }}
                        checked={is_clean}
                      />
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Судалгааны тайлангийн нэр </Label>
                      <Input
                        name="report_name"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_name || ""}
                        invalid={
                          validation.touched.report_name &&
                            validation.errors.report_name
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_name &&
                        validation.errors.report_name ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_name}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ашиглаж байгаа эсэх </Label> <br />
                      <Switch
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        className="me-1 mb-sm-8 mb-2 ms-3"
                        onColor="#626ed4"
                        onChange={() => {
                          setIs_usedBoolean(!is_used);
                        }}
                        checked={is_used}
                      />
                    </div>
                  </Col>

                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ордын нийт талбай (км<sup>2</sup>) </Label>
                      <Input
                        name="area"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.area || ""}
                        invalid={
                          validation.touched.area &&
                            validation.errors.area
                            ? true
                            : false
                        }
                      />
                      {validation.touched.area &&
                        validation.errors.area ? (
                        <FormFeedback type="invalid">
                          {validation.errors.area}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Нөөц тооцсон бүдүүвч схем  </Label>
                      <Input
                        name="storage_scheme"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.storage_scheme || ""}
                        invalid={
                          validation.touched.storage_scheme &&
                            validation.errors.storage_scheme
                            ? true
                            : false
                        }
                      />
                      {validation.touched.storage_scheme &&
                        validation.errors.storage_scheme ? (
                        <FormFeedback type="invalid">
                          {validation.errors.storage_scheme}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Усны физик шинж чанар </Label>
                      <Input
                        name="water_physical_quality"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.water_physical_quality || ""}
                        invalid={
                          validation.touched.water_physical_quality &&
                            validation.errors.water_physical_quality
                            ? true
                            : false
                        }
                      />
                      {validation.touched.water_physical_quality &&
                        validation.errors.water_physical_quality ? (
                        <FormFeedback type="invalid">
                          {validation.errors.water_physical_quality}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Гидрогеологийн структур </Label>
                      <Input
                        name="hydrogeological_structure"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.hydrogeological_structure || ""}
                        invalid={
                          validation.touched.hydrogeological_structure &&
                            validation.errors.hydrogeological_structure
                            ? true
                            : false
                        }
                      />
                      {validation.touched.hydrogeological_structure &&
                        validation.errors.hydrogeological_structure ? (
                        <FormFeedback type="invalid">
                          {validation.errors.hydrogeological_structure}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ариун цэвэр,эрүүл ахуйн шаардлага хангалт </Label>
                      <Input
                        name="sanitary_requirements"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.sanitary_requirements || ""}
                        invalid={
                          validation.touched.sanitary_requirements &&
                            validation.errors.sanitary_requirements
                            ? true
                            : false
                        }
                      />
                      {validation.touched.sanitary_requirements &&
                        validation.errors.sanitary_requirements ? (
                        <FormFeedback type="invalid">
                          {validation.errors.sanitary_requirements}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Тайлан зохиогчийн нэр  </Label>
                      <Input
                        name="report_autor"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_autor || ""}
                        invalid={
                          validation.touched.report_autor &&
                            validation.errors.report_autor
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_autor &&
                        validation.errors.report_autor ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_autor}
                        </FormFeedback>
                      ) : null}
                    </div>

                  </Col>
                  <Col lg={12} className="d-flex justify-content-around mt-3">
                    <button type="submit" className="btn btn-primary"> Хадгалах </button>
                  </Col>
                </Row>
              </Form>
          }
        </Col>

      </Row>

    </>
  )
}

export default Measurement;